module.exports = __webpack_public_path__ + "static/staff-shuttle-service-1d3ecb7a3f73d34ed9ff35aa41c398ef.jpg";